export default __webpack_public_path__ + "static/media/monitor-card.8cd14bd6.svg";